var testimonialJs = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    /**
     *   Video Modal Box
     */
    var modalOverlay = document.querySelectorAll(".js-video-overlay-trigger");
    if (modalOverlay) {
      for (i = 0; i < modalOverlay.length; i++) {
        var modalVideoId = modalOverlay[i].getAttribute("data-video-id"),
          ua = navigator.userAgent.toLowerCase(),
          isSafari = false,
          sandboxFlag = '';

        // Detect browser for allow presentation sandbox flag
        try {
          isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        }
        catch(err) {}
        isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
        sandboxFlag = isSafari ? '' : 'allow-presentation';

        modalOverlay[i].addEventListener("click", function(e) {
          e.preventDefault();
          if (modalVideoId) {
            var modalVideo = new tingle.modal({
              focusAfterClosed: this,
              closeIconInverse: true,
              onClose: function() {
                modalVideo.destroy();
              }
            });
            modalVideo.setContent(
              '<iframe width="100%" height="400" src="https://www.youtube.com/embed/' +
                modalVideoId +
                '?autoplay=1" frameborder="0" sandbox="allow-scripts allow-same-origin ' + sandboxFlag + '" allowfullscreen></iframe>'
            );
            modalVideo.open();
          }
        });
      }
    }

    // init bsslider with skip logic
    updateAllTabSkipAttributes();

    // Common function to manage data-skip-tab attribute on tabs
    function updateTabSkipAttributes(habitat) {
      var tabs = habitat.querySelectorAll('.slider-thumbs-div'),
      windowWidth = window.innerWidth;
      
      for (var m = 0; m < tabs.length; m++) {
        var tab = tabs[m],
        tabContainer = tab.closest('.testimonials-cite--tab'),
        tabIndex = parseInt(tabContainer.getAttribute('data-tab-index')) || (m + 1),
        tabControlDiv = tab.getAttribute('aria-controls') ? habitat.querySelector("#" + tab.getAttribute('aria-controls')) : null;;

        // Remove existing skip attribute first
        tab.removeAttribute('data-skip-tab');
        
        // Apply responsive logic for tab skipping
        if (windowWidth > 1300) {
          // Above 1300px: Skip 4th+ tabs
          if (tabIndex > 4) {
            tab.setAttribute('data-skip-tab', 'true');
            tabContainer.classList.remove('active');
            tabControlDiv ? tabControlDiv.classList.add('hide') : null;
          }
        } else if (windowWidth >= 1080 && windowWidth <= 1300) {
          // 1080-1300px: Skip 3rd+ tabs
          if (tabIndex > 3) {
            tab.setAttribute('data-skip-tab', 'true');
            tabContainer.classList.remove('active');
            tabControlDiv ? tabControlDiv.classList.add('hide') : null;
          }
        }
        // Below 1080px: All tabs accessible (no skip attribute)
      }
    }

    // Function to update all testimonial habitats
    function updateAllTabSkipAttributes() {
      var habitats = document.querySelectorAll('.testimonials-habitat');
      for (var n = 0; n < habitats.length; n++) {
        updateTabSkipAttributes(habitats[n]);

        bsSlider(habitats[n]);
      }
    }

    // Dynamic height calculation for testimonials galleries
    var testimonialsGalleries = document.querySelectorAll('.testimonials-habitat .bs-slider-gallery');
    
    function calculateMaxHeightForGallery(gallery) {
      var blockquotes = gallery.querySelectorAll('blockquote'),
      maxHeight = 0,
      oldGalleryHeight = gallery.offsetHeight;
      
      // Reset min-height temporarily to get natural heights
      gallery.style.minHeight = 'auto';
      
      for (var j = 0; j < blockquotes.length; j++) {
        var blockquote = blockquotes[j],
        originalDisplay = blockquote.style.display,
        originalVisibility = blockquote.style.visibility,
        wasHidden = blockquote.classList.contains('hide');
        
        // Temporarily show hidden elements to measure their height
        if (wasHidden) {
          blockquote.classList.remove('hide');
        }
        
        // Ensure element is visible for measurement
        blockquote.style.visibility = 'hidden';
        blockquote.style.display = 'block';
        
        var height = blockquote.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
        
        // Restore original state
        if (wasHidden) {
          blockquote.classList.add('hide');
        }
        blockquote.style.display = originalDisplay;
        blockquote.style.visibility = originalVisibility;
      }
      
      // Apply the maximum height as min-height
      if (maxHeight > 0) {
        maxHeight = maxHeight + 60; 

        // If the old gallery height is less than the calculated max height, use the old height
        if (oldGalleryHeight > 0 && oldGalleryHeight > maxHeight) { 
          maxHeight = oldGalleryHeight;
        }

        gallery.style.minHeight = maxHeight + 'px';
      }
    }
    
    function calculateAllGalleries() {
      for (var k = 0; k < testimonialsGalleries.length; k++) {
        calculateMaxHeightForGallery(testimonialsGalleries[k]);
      }
    }
    
    if (testimonialsGalleries.length > 0) {
      // Calculate on load
      calculateAllGalleries();
      
      // Recalculate on window resize
      window.addEventListener('resize', function() {
        calculateAllGalleries();
        updateAllTabSkipAttributes();
      });
    }
  };

  init();
})();
